import React from 'react';
import { Tooltip } from '@prima-afp/prima-ui-elements/dist/core';
import InfoIcon from '../../../../assets/icons/info-green.svg';
import { BoxStyled, DescriptionStyles, TitleStyles } from './styles';

const TooltipCustom = ({ title, description }) => {

  const Content = () => {
    return (
      <BoxStyled>
        <TitleStyles>{ title }</TitleStyles>
        <DescriptionStyles>{ description }</DescriptionStyles>
      </BoxStyled>
    )
  }

  return (
    <Tooltip content={ <Content /> } theme='light' orientation='top' >
      { Content }
      <img width='15' src={InfoIcon} alt='tooltip' />
    </Tooltip>
  )
}

export default TooltipCustom;